<mat-form-field class="w-100">
  <mat-label>{{ placeholder }}</mat-label>
  <!--$$$ VALIDAR DISABLED -->
  <mat-select [formControl]="dispatchTypeCode"
  [disabled]="disabledSelect"
  [multiple]="isMultiple"
  (selectionChange)="onChangeTypeOfDispatch()"
  (openedChange)="onGetTypeOfDispatches()"
  >
  <!-- [value]="type.configValue"  TEMPORALMENTE COMENTADO-->
    <mat-option>{{ isNotRequired? 'NINGUNO': 'SELECCIONE'}}</mat-option>
    <mat-option
      *ngFor="let type of listOfDispatchTypes"
      [value]="type.configValue"
      >
      {{ type.configName | uppercase }}
    </mat-option>
  </mat-select>
  <mat-hint class="message-info" *ngIf="hint && listOfDispatchTypes.length==0">{{ hint }}</mat-hint>
</mat-form-field>
